// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import apiConfig from '@/config'
import httpRequest from '@/utils/request'
import fastClick from 'fastclick'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { Anchor, BackTop } from 'ant-design-vue'
import WXConfig from '@javascripts/wx.jsapi'
import _ from 'lodash'
import Clipboard from 'clipboard'
import { verify } from '@/utils'

import animated from 'animate.css'
import { DatetimePicker, Area, Picker } from 'vant'
import 'vant/lib/index.css'

Vue.use(Area)
Vue.use(Picker)
Vue.use(DatetimePicker)

Vue.directive('focus', {
  bind: function() {
    //指令绑定 到元素上时立即实行该bing函数，只执行一次
    //在每个函数中第一个参数永远书el
    //在元素刚绑定了指令的时候，还没有插入到dom中去这时候调用focus没作用，只有插入dom之后才能获取焦点
    // el.focus()
  },
  inserted: function(el) {
    //元素插入到DOM中的时候，会执行inserted，触发一次
    el.focus()
  },
  updated: function() {
    //当组件vnode更新的时候执行update可能会触发多次
  },
})

import '@javascripts/validate.js'

import '@styles/iconfont.css'
import '@styles/fonts.css'
import 'swiper/dist/css/swiper.css'
import '@styles/keyframes.css'
import '@styles/border.css'
import '@styles/button.scss'
import '@styles/form.scss'
import '@styles/default.scss'
import '@styles/rebuild.scss'

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

Vue.use(VueAwesomeSwiper)
Vue.use(animated)
Vue.use(Anchor)
Vue.use(BackTop)
Vue.config.productionTip = false
Vue.prototype._ = _
Vue.prototype.WXConfig = WXConfig
Vue.prototype.clipboard = Clipboard
Vue.prototype.$request = httpRequest
Vue.prototype.$apiConfig = apiConfig
fastClick.attach(document.body)

let isWxinit = false
router.beforeEach((to, from, next) => {
  let _name = ''
  let jicePageTitle = ''
  if (to.meta.title) {
    _name = to.meta.title || '绝对夜计划'
    jicePageTitle = to.meta.jicePageTitle || _name
    window.document.title = _name
  }
  if (from.query.channel) {
    //路由切换时，如果没有就添加，有就跳过执行，添加固定参数
    if (!to.query.channel) {
      //准备一个跳转的query对象
      let query = to.query
      query.channel = from.query.channel
      query.campaign = from.query.campaign
      query.utm_campaign = from.query.utm_campaign
      query.utm_medium = from.query.utm_medium
      next({
        path: to.path,
        query: query,
      })
      return
    }
  }
  if (from.query.access_id) {
    //路由切换时，如果没有就添加，有就跳过执行，添加固定参数
    if (!to.query.access_id) {
      //准备一个跳转的query对象
      let query = to.query
      query.access_id = from.query.access_id
      query.activity_id = from.query.activity_id
      next({
        path: to.path,
        query: query,
      })
      return
    }
  }

  if (_.isEmpty(store.state.authorization)) {
    console.log('No authorization')
    if (to.matched.some(m => m.meta.auth)) {
      console.log('Need login')
      alert('您还未登录，需要登录后可获得完整体验')
      let query = to.query
      query.redirect = decodeURIComponent(to.fullPath)
      next({
        path: '/login',
        query,
      })
      return
    }
  }
  _jcq.push([
    '_track',
    'pageview',
    {
      url: apiConfig.domain + to.path,
      urlquery: to.query,
      title: jicePageTitle,
    },
  ])
  if (verify.isIOS()) {
    if (!isWxinit && verify.isWeixin() && !isWxinit) {
      WXConfig.getConfig(window.location.href)
      isWxinit = true
    }
    next()
  } else {
    if (verify.isWeixin()) {
      WXConfig.getConfig(window.location.href)
    }
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js